import type { MmkItem } from "../types/mmk";
import { isPersonalMmkItem } from "./mmkPersonal";

export function toMmkPublicLabel(mkkNumber: string): string {
  return (mkkNumber || "").replace(/MMK/gi, "MMM").replace(/MKK/gi, "MMM");
}

export function getMmkCardDisplayLabel(
  item: Pick<MmkItem, "source" | "mkk_number">,
): string {
  if (isPersonalMmkItem(item)) return "Personal";
  return toMmkPublicLabel(item.mkk_number ?? "");
}
